export const ru = {
    'unhandled-error': 'Во время запроса произошла непредвиденная ошибка'
};
